export function payrollNavigationRows(rows,group){
 if(!group)return rows;
 const groups=new Map();for(const row of rows){const key=String(row[group]||'Sin dato');if(!groups.has(key))groups.set(key,[]);groups.get(key).push(row);}return [...groups.values()].flat();
}
